import { createComponent } from '@carvana/merch-components';

export const Content = createComponent('div', {
  className:
    'flex flex-col gap-16 max-w-[424px] mx-auto py-24 w-full m:px-0 m:py-40'
});

export const EVCreditPillContainer = createComponent('div', {
  className:
    'border border-grey-2 center flex gap-8 items px-12 py-8 rounded-full text-blue-6 text-sm w-fit'
});
